import React, { useState } from "react";

/**
 * Tabs component with tab buttons and content panels
 *
 * @param {Array} tabs - Array of tab objects with { id, label, icon?, content }
 * @param {string} defaultTab - ID of the default tab to show
 */
export default function Tabs({ tabs, defaultTab }) {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  const activeTabData = tabs.find(tab => tab.id === activeTab);

  return (
    <div className="flex flex-col h-full">
      {/* Tab buttons */}
      <div className="flex gap-1 border-b border-neutral-800 bg-secondary px-2 pt-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={`
              px-4 py-2 rounded-t-md font-semibold text-[11px] uppercase tracking-wider transition-all duration-150 focus:outline-none focus:ring-1 focus:ring-accent border-x border-t
              ${activeTab === tab.id
                ? 'bg-primary text-text border-neutral-800 -mb-px'
                : 'text-text-muted hover:text-text border-transparent'
              }
            `}
          >
            {tab.icon && <span className="mr-2">{tab.icon}</span>}
            {tab.label}
          </button>
        ))}
      </div>

      {/* Tab content */}
      <div className="flex-1 overflow-auto thin-scroll bg-primary p-6">
        {activeTabData?.content}
      </div>
    </div>
  );
}
